import React from 'react'
import ViewBatchLayout from './ViewBatchLayout'
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout'

const ViewBatchLayoutWrapper = () => {
  return (
    <SideNavLayout>
        <ViewBatchLayout/>
    </SideNavLayout>
  )
}

export default ViewBatchLayoutWrapper